import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ThemeService } from "./services/theme.service";
import { NgxSpinnerModule } from "ngx-spinner";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ModalModule } from "ngx-bootstrap/modal";

import * as $ from "jquery";
import * as moment from "moment";
import {
    DxToolbarModule,
    DxMenuModule,
    DxRangeSelectorModule,
    DxPopupModule,
    DxPopoverModule,
    DxChartModule,
    DxPieChartModule,
    DxVectorMapModule,
    DxDataGridModule,
    DxBulletModule,
    DxButtonModule,
    DxProgressBarModule,
    DxFormModule,
    DxListModule,
    DxTemplateModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxNumberBoxModule,
    DxResponsiveBoxModule,
    DxCheckBoxModule,
    DxSelectBoxModule,
    DxBoxModule,
    DxRadioGroupModule,
    DxDropDownBoxModule,
    DxScrollViewModule,
    DxFileUploaderModule,
    DxDrawerComponent,
    DxDrawerModule,
    DxTabsModule,
    DxTabPanelModule,
    DxTreeListModule,
    DxTreeViewModule,
    DxTooltipModule,
    DxLookupModule,
    DxSpeedDialActionModule,
    DxLoadIndicatorComponent,
    DxLoadIndicatorModule,
    DxFileManagerModule,
    DxHtmlEditorModule,
    DxMapModule,
    DxContextMenuModule,
    DxTagBoxModule,
    DxDropDownButtonModule,
    DxButtonGroupModule,
    DxAutocompleteModule,
    DxAccordionModule,
    DxLoadPanelModule,
    DxColorBoxComponent,
    DxColorBoxModule,
    DxRangeSliderComponent,
    DxRangeSliderModule,
    DxSwitchModule,
    DxDateBoxModule,
    DxLinearGaugeModule,
    DxTextAreaModule,
    DxTemplateHost,
    DxMultiViewModule
} from "devextreme-angular";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { DashboardSectorsComponent } from "./views/main/sectors/sectors.component";
import { DashboardProductsComponent } from "./views/main/products/products.component";
import { DashboardChannelsComponent } from "./views/main/channels/channels.component";
import { RangeSelectorComponent } from "./components/rangeselector/rangeselector.component";
import { DateSwitcherComponent } from "./components/date-switcher/date-switcher.component";
import { ComparingBarsComponent } from "./components/comparing-bars/comparing-bars.component";
import { ParametersComponent } from "./components/parameters/parameters.component";
import { CaptionComponent } from "./components/caption/caption.component";
import { ProductsGridComponent } from "./components/products-grid/products-grid.component";
import { ProductsChartComponent } from "./components/products-chart/products-chart.component";
import { ProductsInfoComponent } from "./components/products-info/products-info.component";
import { AnaRegistriRifiutiComponent } from "./views/ana-registri-rifiuti/ana-registri-rifiuti.component";
import { RegistriRifiutiGridComponent } from "./components/registri-rifiuti-grid/registri-rifiuti-grid.component";
import { UppercaseDirective } from "./directive/uppercase.directive";
import { NumbersOnlyDirective } from "./directive/numbers-only.directive";
//import { AnagraficaCausaliRifiutiComponent } from './views/anagrafica-causali-rifiuti/anagrafica-causali-rifiuti.component';
import { ArtInputCheckNumberComponent } from "./components/art-input-check-number/art-input-check-number.component";

import { LoginComponent } from "./views/login/login.component";
import { Apiservice } from "./services/api.service";
import { Utenteservice } from "./services/utente.service";
import { MainComponent } from "./views/main/main.component";
import { AnaUtentiComponent } from "./views/ana-utenti/ana-utenti.component";
import { GrigliaComponent } from "./components/griglia/griglia.component";
import { locale, loadMessages } from "devextreme/localization";
import { ToolbarComponent } from "./components/toolbar/toolbar.component";
import { NicaFooterComponent } from "./components/nica-footer/nica-footer.component";
import { NicaHeaderComponent } from "./components/nica-header/nica-header.component";

import { FormComponent } from "./components/form/form.component";
import { MessaggioComponent } from "./components/messaggio/messaggio.component";
import { SelezioneComponent } from "./components/selezione/selezione.component";
import { DataService } from "./services/data.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { DetailComponent } from "./components/detail/detail.component";
import { TaskActionComponent } from "./components/task-action/task-action.component";
import { AnaTrasportatoriComponent } from "./views/ana-trasportatori/ana-trasportatori.component";
import { AnaSmaltitoriComponent } from "./views/ana-smaltitori/ana-smaltitori.component";
import { ScreenService } from "./services/screen.service";
import { SideNavigationMenuModule } from "./components/side-navigation-menu/side-navigation-menu.component";
import { InterceptorService } from "./services/interceptor.service";
import { EmailComponent } from "./widgets/email/email.component";
import { OwnerComponent } from "./views/main/owner/owner.component";
import { NicatextboxiconComponent } from "./components/nicatextboxicon/nicatextboxicon.component";
import { NicaHelpComponent } from "./components/nica-help/nica-help.component";
import { NicaFormToolbarComponent } from "./components/shared/nica-form-toolbar/nica-form-toolbar.component";
import { NicaLicenzaInfoComponent } from "./components/shared/nica-licenza-info/nica-licenza-info.component";

import { OverlaySideFormComponent } from "./components/shared/overlay-side-form/overlay-side-form.component";
import { OverlaySideFormService } from "./components/shared/overlay-side-form/overlay-side-form.service";

import { NicaMainMenuComponent } from "./layout/nica-main-menu/nica-main-menu.component";
import { NicaChildMenuListComponent } from "./layout/nica-child-menu-list/nica-child-menu-list.component";
import { NicaSideMenuComponent } from "./layout/nica-side-menu/nica-side-menu.component";
import { NicaPrefMenuComponent } from "./layout/nica-pref-menu/nica-pref-menu.component";
import { AnteprimaPDfComponent } from "./components/shared/anteprima-pdf/anteprima-pdf.component";
import { AnacomuniComponent } from "./components/anagrafiche/anacomuni/anacomuni.component";
import { NicaWidgetComponent } from "./widgets/nica-widget/nica-widget.component";

import { DashboardComponent } from "./views/dashboard/dashboard.component";
import { CerComponent } from "./components/anagrafiche/cer/cer.component";
//import { TrasportatoriComponent } from './components/anagrafiche/Testtrasportatori/trasportatori.component';
import { BreadcrumbsComponent } from "./layout/breadcrumbs/breadcrumbs.component";
import { NicaChartMakerComponent } from "./components/shared/nica-chart-maker/nica-chart-maker.component";
import { NicaTabComponent } from "./components/nica-anagrafica-tabs/nica-tab/nica-tab.component";
import { NicaTabsComponent } from "./components/nica-anagrafica-tabs/nica-tabs/nica-tabs.component";
import { ViewDatigeneraliSoggettiComponent } from "./components/viste/view-datigenerali-soggetti/view-datigenerali-soggetti.component";
import { ViewDatigeneraliSedeComponent } from "./components/viste/view-datigenerali-sede/view-datigenerali-sede.component";
import { ViewUnitaLocaliComponent } from "./components/viste/view-unita-locali/view-unita-locali.component";
import { ViewUnitaLocaliDatiGeneraliComponent } from "./components/viste/view-unita-locali-dati-generali/view-unita-locali-dati-generali.component";
import { DashboardTabsComponent } from "./views/dashboard/dashboard-tabs/dashboard-tabs.component";
import { RentriComponent } from "./views/rentri/rentri.component";
import { FormulariRentriComponent } from "./views/rentri/formulari/formulari-rentri.component";
import { MovimentiComponent } from "./views/rentri/movimenti/movimenti.component";
import { NicaMapsComponent } from "./widgets/nica-maps/nica-maps.component";
import { NicaFormComponent } from "./components/nica-form/nica-form.component";
import { NicaDynamicContentComponent } from "./components/nica-dynamic-content/nica-dynamic-content.component";
import { AnagraficaService } from "./services/anagrafica.service";
import { AnaSoggettoComponent } from "./views/ana-soggetto/ana-soggetto.component";
import { AnaUnitaLocaliComponent } from "./views/ana-soggetto/ana-unita-locali/ana-unita-locali.component";
import { AutistiComponent } from "./components/autisti/autisti.component";
import { AnaAutomezzoComponent } from "./views/ana-automezzo/ana-automezzo.component";
import { AnaAutorizzazioneComponent } from "./views/ana-autorizzazione/ana-autorizzazione.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NicaModelloStampaComponent } from "./widgets/nica-modello-stampa/nica-modello-stampa.component";
import { NicaInfoAnagraficaAziendaComponent } from "./components/anagrafiche/nica-info-anagrafica-azienda/nica-info-anagrafica-azienda.component";
import { ContattiComponent } from "./components/contatti/contatti.component";
import { MainAnaSoggettoComponent } from "./components/views/main-ana-soggetto/main-ana-soggetto.component";
import { SoggettoComponent } from "./components/soggetto/soggetto.component";
import { MagazzinoRifiutiCerComponent } from "./components/magazzino/magazzino-rifiuti-cer/magazzino-rifiuti-cer.component";
import { NicaRightPanelComponent } from "./components/shared/nica-right-panel/nica-right-panel.component";

import { CantiereComponent } from "./components/cantiere/cantiere.component";
import { CausalirifiutiComponent } from "./views/causalirifiuti/causalirifiuti.component";
import { AnagraficaGridComponent } from "./views/ana-grid/ana-grid.component";
import { ElencocertrasportabiliComponent } from "./components/elencocertrasportabili/elencocertrasportabili.component";
import { CarrozzeriemobiliComponent } from "./components/carrozzeriemobili/carrozzeriemobili.component";
import { GestionecerComponent } from "./components/gestionecer/gestionecer.component";
import { GenerateFormComponent } from "./components/generate-form/generate-form.component";
import { TabellaCausaliRifiutiComponent } from "./components/tabella-causali-rifiuti/tabella-causali-rifiuti.component";
import { RegistririfiutiComponent } from "./components/registririfiuti/registririfiuti.component";
import { GestioneautomezzicerComponent } from "./components/gestioneautomezzicer/gestioneautomezzicer.component";
import { OdataComuniComponent } from "./components/odata-comuni/odata-comuni.component";
import { HomepageComponent } from "./components/homepage/homepage.component";
import { PosizioniComponent } from "./components/posizioni/posizioni.component";
import { VivifirComponent } from "./components/vivifir/vivifir.component";
import { ConfigurazioneRentriComponent } from "./components/configurazione-rentri/configurazione-rentri.component";
import { NicaAnagraficaComponent } from "./components/nica-anagrafica/nica-anagrafica.component";
import { NicaHelpNDocComponent } from "./components/nica-help-n-doc/nica-help-n-doc.component";
import { AnaProduttoriComponent } from "./views/ana-produttori/ana-produttori.component";

//import { Causali2Component } from './components/causali2/causali2.component';
import { NicaChartMakerFormComponent } from "./components/shared/nica-chart-maker-form/nica-chart-maker-form.component";
import { NicaGestioneAziendaComponent } from "./components/nica-gestione-azienda/nica-gestione-azienda.component";
import { ExcelExporterComponent } from "./components/shared/excel-exporter/excel-exporter.component";
import { PermessiutentiComponent } from "./components/permessiutenti/permessiutenti.component";
import { MovimentiCaricoScaricoComponent } from "./views/movimenti-carico-scarico/movimenti-carico-scarico.component";
//import { PermessiutentiComponent } from './components/permessiutenti/permessiutenti.component';

import { GruppiComponent } from "./components/gruppi/gruppi.component";
import { EditgruppiComponent } from "./components/editgruppi/editgruppi.component";
import { EditAutocompleteComponent } from "./components/edit-autocomplete/edit-autocomplete.component";
import { SchedarifiutiComponent } from "./views/schedarifiuti/schedarifiuti.component";
import { ImballiComponent } from "./components/imballi/imballi.component";
import { AllegatiComponent } from "./components/allegati/allegati.component";
import { NicaFiltroComponent } from "./components/shared/nica-filtro/nica-filtro.component";
import { GiacenzerifiutiComponent } from "./components/giacenzerifiuti/giacenzerifiuti.component";
import { DistinctArrayPipe } from "./components/shared/distinct-array.pipe";
import { ReplaceUndefinedPipe } from "./pipes/replaceUndefined.pipe";

import { SafePipe } from "./pipes/safe.pipe";
import { NicaplayerComponent } from "./nicaplayer/nicaplayer.component";
import { NicaFileManagerComponent } from "./components/nica-file-manager/nica-file-manager.component";
import { GrigliaModelliComponent } from "./components/shared/griglia-modelli/griglia-modelli.component";
import { AnaAlboComponent } from "./views/ana-albo/ana-albo.component";
import { EditSearchComponent } from "./components/shared/edit-search/edit-search.component";
import { ConfigurazioniModuliComponent } from "./views/configurazioni-moduli/configurazioni-moduli.component";
import { DettagliMovimentiCaricoScaricoComponent } from "./views/dettagli-movimenti-carico-scarico/dettagli-movimenti-carico-scarico.component";
import { StampaRegistriCaricoScaricoComponent } from "./views/stampa-registri-carico-scarico/stampa-registri-carico-scarico.component";
import { AutomezzoComponent } from "./components/automezzo/automezzo.component";
import { PannelloGestioneStruttureExcelComponent } from "./components/shared/pannello-gestione-strutture-excel/pannello-gestione-strutture-excel.component";
import { TestComponent } from "./components/test/test.component";
//import { ExtendnicaanagraficaComponent } from './components/extendnicaanagrafica/extendnicaanagrafica.component';
import { StaticMenuComponent } from "./layout/static-menu/static-menu.component";
import { StaticMenuFunctionsComponent } from "./layout/static-menu-functions/static-menu-functions.component";
import { MagazzinoComponent } from "./components/magazzino/magazzino.component";
import { HomepagewwComponent } from "./components/homepageww/homepageww.component";
import { RemoveTextBetweenCharactersPipe } from "./pipes/removeTextBetweenCharacters.pipe";
import { EditgiacenzainizialeComponent } from "./components/editgiacenzainiziale/editgiacenzainiziale.component";
import { EditorElementComponent } from "./components/nica-form/editor-element/editor-element.component";
import { NicaGridComponent } from "./components/versione2/nica-grid/nica-grid.component";
import { NicaGridService } from "./components/versione2/nica-grid.service";
import { GestioneCarichiMovimentoComponent } from "./views/movimenti-carico-scarico/gestione-carichi-movimento/gestione-carichi-movimento.component";
import { GestioneAltriSoggettiComponent } from "./views/movimenti-carico-scarico/gestione-altri-soggetti/gestione-altri-soggetti.component";
import { LottoComponent } from "./components/lotto/lotto.component";
import { NicaWrapperComponent } from "./components/nica-wrapper/nica-wrapper.component";
import { NicaPopupContentComponent } from "./components/nica-popup/nica-popup-content/nica-popup-content.component";
import { NicaPopupWrapperComponent } from "./components/nica-popup/nica-popup-wrapper/nica-popup-wrapper.component";
import { NewNicaFormComponent } from "./components/nica-form/new-nica-form.component";
import { InputSelectElComponent } from "./components/nica-form/editor-element/input-select-el/input-select-el.component";
import { GiacenzeRifiutoMovimentoComponent } from "./views/movimenti-carico-scarico/giacenze-rifiuto-movimento/giacenze-rifiuto-movimento.component";
import { NicaDataGridComponent } from "./components/nica-data-grid/nica-data-grid.component";
import { EmissioneFormulariComponent } from "./views/emissione-formulari/emissione-formulari.component";
import { GestioneLavorazioniRifiutiComponent } from "./views/movimenti-carico-scarico/gestione-lavorazioni-rifiuti/gestione-lavorazioni-rifiuti.component";
import { TdItemComponent } from "./components/nica-data-grid/td-item/td-item.component";
import { TestiAdrComponent } from "./components/testi-adr/testi-adr.component";
import { AnaMagazziniComponent } from "./views/ana-magazzini/ana-magazzini.component";
import { GestioneRintracciabilitaRifiutiComponent } from "./views/movimenti-carico-scarico/gestione-rintracciabilita-rifiuti/gestione-rintracciabilita-rifiuti.component";
import { GestioneMiscelazioniRifiutiComponent } from "./views/movimenti-carico-scarico/gestione-miscelazioni-rifiuti/gestione-miscelazioni-rifiuti.component";
import { InputCheckboxElComponent } from "./components/nica-form/editor-element/input-checkbox-el/input-checkbox-el.component";
import { InfousergruppiComponent } from "./components/widgets/infousergruppi/infousergruppi.component";
import { WebcamnicaComponent } from "./components/widgets/webcamnica/webcamnica.component";
import { InputDateboxElComponent } from "./components/nica-form/editor-element/input-datebox-el/input-datebox-el.component";

import { SelectCausaliPosizioniComponent } from "./components/widgets/select-causali-posizioni/select-causali-posizioni.component";
import { DynamicSelectComponent } from "./components/dynamic-select/dynamic-select.component";
import { AnaAutistiComponent } from "./views/ana-autisti/ana-autisti.component";
import { AnaCantieriComponent } from "./views/ana-cantieri/ana-cantieri.component";
import { AnaLottiComponent } from "./views/ana-lotti/ana-lotti.component";
import { InputRadiogroupElComponent } from "./components/nica-form/editor-element/input-radiogroup-el/input-radiogroup-el.component";
import { AnaSchedaRifiutiComponent } from "./views/ana-scheda-rifiuti/ana-scheda-rifiuti.component";
import { Componente1Component } from "./components/carmine/componente1/componente1.component";
import { InputFileElComponent } from "./components/nica-form/editor-element/input-file-el/input-file-el.component";
import { GiacenzeRifiutiComponent } from "./views/giacenze/giacenze-rifiuti.component";
import { StatisticheRifiutiComponent } from "./views/statistiche-rifiuti/statistiche-rifiuti.component";
import { ExtendfilterComponent } from "./views/statistiche-rifiuti/extendfilter/extendfilter.component";
import { ToolbarNavigationComponent } from "./component_carmine/toolbar-navigation/toolbar-navigation.component";
import { WidgetGiacenzaComponent } from "./component_carmine/widget-giacenza/widget-giacenza.component";
import { WidgetGraficiComponent } from "./components/widget-grafici/widget-grafici.component";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { StatisticarifiutiGraficiComponent } from "./views/statisticarifiuti-grafici/statisticarifiuti-grafici.component";
import { ShowRentriComponent } from "./components/show-rentri/show-rentri.component";
import { PippoComponent } from "./components/pippo/pippo.component";
import { ShowRentriElencoMovimentiComponent } from "./components/show-rentri-elenco-movimenti/show-rentri-elenco-movimenti.component";
import { CrmComponent } from "./views/crm/crm.component";
import { CrmContattiComponent } from "./components/CRM/crm-contatti/crm-contatti.component";
import { CrmBancheComponent } from "./components/CRM/crm-banche/crm-banche.component";
import { CrmElencoRecapitiComponent } from "./components/CRM/crm-elenco-recapiti/crm-elenco-recapiti.component";
import { CrmProcedureComponent } from "./components/CRM/crm-procedure/crm-procedure.component";
import { CrmAgentiComponent } from "./components/CRM/crm-agenti/crm-agenti.component";
import { CrmTabPanelComponent } from "./components/CRM/crm-tab-panel/crm-tab-panel.component";
import { CrmAssegnaProcedureComponent } from "./components/CRM/crm-assegna-procedure/crm-assegna-procedure.component";
import { CrmDiarioAttivitaComponent } from "./components/CRM/crm-diario-attivita/crm-diario-attivita.component";
import { NicaFormTabsComponent } from "./components/nica-form-tabs/nica-form-tabs.component";
import { CrmTipoProcedureComponent } from "./components/CRM/crm-tipo-procedure/crm-tipo-procedure.component";
import { CrmFilesListComponent } from "./components/CRM/crm-files-list/crm-files-list.component";
import { CrmVistaProcedureContattiComponent } from "./components/CRM/crm-vista-procedure-contatti/crm-vista-procedure-contatti.component";
import { CrmDashboardComponent } from "./components/CRM/crm-dashboard/crm-dashboard.component";
import { CrmLineChartStatisticheComponent } from "./components/CRM/crm-line-chart-statistiche/crm-line-chart-statistiche.component";
import { CrmStatProcedureComponent } from "./components/CRM/crm_stat_procedure/crm_stat_procedure.component";
import { CrmStatisticheComponent } from "./components/CRM/crm_statistiche/crm_statistiche.component";
import { CrmPieChartComponent } from "./components/CRM/crm_pie_charts/crm_pie_charts.component";
import { CrmTagsListComponent } from "./components/CRM/crm_tags_list/crm_tags_list.component";
import { CrmDettagliProcedureContattiComponent } from "./components/CRM/crm_dettagli_procedure_contatti/crm_dettagli_procedure_contatti.component";
import { CrmMasterDetailContattiComponent } from "./components/CRM/crmMasterDetailContatti/crmMasterDetailContatti.component";
import { CrmSediContattoComponent } from "./components/CRM/crmSediContatto/crmSediContatto.component";
import { InputSwitchElComponent } from "./components/nica-form/editor-element/input-switch-el/input-switch-el.component";
import { ElencoAttivitaComponent } from "./components/CRM/elenco-attivita/elenco-attivita.component";
import { RiepilogoProceduraComponent } from './components/riepilogo-procedura/riepilogo-procedura.component';
import { HoverTooltipDirective } from "./directive/hoverTooltip.directive";
import { FileDragDropDirective } from "./directive/fileDragAndDrop.directive";
import { CrmMailComponent } from './components/CRM/crm-mail/crm-mail.component';
import { CrmEmailEditorComponent } from "./components/CRM/crmEmailEditor/crmEmailEditor.component";
import { CrmEmailInviateComponent } from "./components/CRM/crm_email_inviate/crm_email_inviate.component";
import { NicaPopupTextComponent } from "./components/nica-popup/nica-popup-text/nica-popup-text.component";
import { CrmAggiornamentiComponent } from "./components/CRM/crmAggiornamenti/crmAggiornamenti.component";
import { CrmSendMessaggeComponent } from './components/CRM/crm-send-messagge/crm-send-messagge.component';
import { CheckVisualElComponent } from "./components/nica-form/editor-element/check-visual-el/check-visual-el.component";
import { AllineaRegistroRentriComponent } from './components/allinea-registro-rentri/allinea-registro-rentri.component';
import { GaugesOwnerComponent } from './components/gauges-owner/gauges-owner.component';
import { PopupStampaRegistriComponent } from "./views/stampa-registri-carico-scarico/components/popup-stampa-registri/popup-stampa-registri.component";
import { PopupEsportazioneRentriComponent } from "./views/stampa-registri-carico-scarico/components/popup-esportazione-rentri/popup-esportazione-rentri.component";
import { PopupEsportazioneFilesComponent } from "./views/stampa-registri-carico-scarico/components/popup-esportazione-files/popup-esportazione-files.component";
import { StampaContrattoComponent } from './components/CRM/stampa-contratto/stampa-contratto.component';
import { DynamicHostDirective } from "./directive/dynamicHost.directive";
import { DynamicContentAiComponent } from './components/new-nica-ai/dynamic-content-ai/dynamic-content-ai.component';
import { NewNicaAiComponent } from "./components/new-nica-ai/new-nica-ai.component";
import { GestioneFormulariComponent } from './views/gestione-formulari/gestione-formulari.component';
import { PopupGestioneFirDigitaliComponent } from './components/popup-gestione-fir-digitali/popup-gestione-fir-digitali.component';
import { CrmComuniComponent } from "./components/CRM/crm_comuni/crm_comuni.component";
import { DatiTrasportoComponent } from './components/popup-gestione-fir-digitali/forms/dati-trasporto/dati-trasporto.component';
import { AggiungiAllegatoComponent } from './components/popup-gestione-fir-digitali/forms/aggiungi-allegato/aggiungi-allegato.component';
import { AggiungiAnnotazioneComponent } from './components/popup-gestione-fir-digitali/forms/aggiungi-annotazione/aggiungi-annotazione.component';
import { AnnullamentoComponent } from "./components/popup-gestione-fir-digitali/forms/annullamento/annullamento.component";
import { AggiungiNuovoDestinatarioComponent } from './components/popup-gestione-fir-digitali/forms/aggiungi-nuovo-destinatario/aggiungi-nuovo-destinatario.component';
import { DatiAccettazioneComponent } from './components/popup-gestione-fir-digitali/forms/dati-accettazione/dati-accettazione.component';
import { NicaPopupPdfComponent } from "./components/nica-popup/nica-popup-pdf/nica-popup-pdf.component";
import { DatiQuantitaComponent } from './components/popup-gestione-fir-digitali/forms/dati-quantita/dati-quantita.component';
import { NicaToastComponent } from './components/nica-toast/nica-toast.component';
import { GestioneDispositiviComponent } from './components/gestione-dispositivi/gestione-dispositivi.component';
import { AssociaDispositivoComponent } from './components/associa-dispositivo/associa-dispositivo.component';
import { QRCodeComponent, QRCodeModule } from "angularx-qrcode";
import { ListaAllegatiAnnotazioniComponent } from "./components/popup-gestione-fir-digitali/lista-allegati-annotazioni/lista-allegati-annotazioni.component";
import { NicaTreCxCallComponent } from "./components/nica-3cx-call/nica-3cx-call.component";

let messagesIt = require("devextreme/localization/messages/it.json");

loadMessages(messagesIt);

locale(navigator.language);

@NgModule({
    declarations: [
        StatisticarifiutiGraficiComponent,
        AppComponent,
        HeaderComponent,
        DashboardSectorsComponent,
        DashboardProductsComponent,
        DashboardChannelsComponent,
        FooterComponent,
        StatisticheRifiutiComponent,
        Componente1Component,
        CrmContattiComponent,
        CrmFilesListComponent,
        //CustomersComponent,
        EmissioneFormulariComponent,
        RangeSelectorComponent,
        DateSwitcherComponent,
        ComparingBarsComponent,
        ParametersComponent,
        CaptionComponent,
        ProductsGridComponent,
        ProductsChartComponent,
        ProductsInfoComponent,
        AnaRegistriRifiutiComponent,
        RegistriRifiutiGridComponent,
        UppercaseDirective,
        NumbersOnlyDirective,
        CrmComponent,
        ArtInputCheckNumberComponent,
        LoginComponent,
        MainComponent,
        AnaUtentiComponent,
        GrigliaComponent,
        ToolbarComponent,
        NicaHeaderComponent,
        NicaFooterComponent,
        NicaAnagraficaComponent,
        FormComponent,
        MessaggioComponent,
        SelezioneComponent,
        AnaProduttoriComponent,
        DetailComponent,
        TaskActionComponent,
        AnaTrasportatoriComponent,
        AnaTrasportatoriComponent,
        AnaSmaltitoriComponent,
        EmailComponent,
        OwnerComponent,
        NicatextboxiconComponent,
        NicaHelpComponent,
        NicaFormToolbarComponent,
        NicaLicenzaInfoComponent,
        OverlaySideFormComponent,
        NicaMainMenuComponent,
        NicaChildMenuListComponent,
        NicaSideMenuComponent,
        NicaPrefMenuComponent,
        AnteprimaPDfComponent,
        AnacomuniComponent,
        NicaWidgetComponent,
        AllegatiComponent,
        DashboardComponent,
        CerComponent,
        BreadcrumbsComponent,
        NicaChartMakerComponent,
        NicaTabComponent,
        NicaTabsComponent,
        ViewDatigeneraliSoggettiComponent,
        ViewDatigeneraliSedeComponent,
        ViewUnitaLocaliComponent,
        ViewUnitaLocaliDatiGeneraliComponent,
        DashboardTabsComponent,
        RentriComponent,
        FormulariRentriComponent,
        MovimentiComponent,
        NicaMapsComponent,
        NicaFormComponent,
        NicaDynamicContentComponent,
        AnaSoggettoComponent,
        AnaUnitaLocaliComponent,
        AutistiComponent,
        AnaAutomezzoComponent,
        AutomezzoComponent,
        AnaAutorizzazioneComponent,
        NicaModelloStampaComponent,
        NicaInfoAnagraficaAziendaComponent,
        ContattiComponent,
        MainAnaSoggettoComponent,
        SoggettoComponent,
        MagazzinoComponent,
        MagazzinoRifiutiCerComponent,
        NicaRightPanelComponent,
        AnagraficaGridComponent,
        CantiereComponent,
        CausalirifiutiComponent,
        ElencocertrasportabiliComponent,
        CarrozzeriemobiliComponent,
        GestionecerComponent,
        GenerateFormComponent,
        TabellaCausaliRifiutiComponent,
        RegistririfiutiComponent,
        GestioneautomezzicerComponent,
        OdataComuniComponent,
        HomepageComponent,
        HomepagewwComponent,
        PosizioniComponent,
        VivifirComponent,
        ConfigurazioneRentriComponent,
        NicaHelpNDocComponent,
        NicaChartMakerFormComponent,
        NicaGestioneAziendaComponent,
        ExcelExporterComponent,
        NicaFileManagerComponent,
        //PermessiutentiComponent
        PermessiutentiComponent,
        ExcelExporterComponent,
        MovimentiCaricoScaricoComponent,
        GruppiComponent,
        EditgruppiComponent,
        EditAutocompleteComponent,
        TestComponent,
        SchedarifiutiComponent,
        ImballiComponent,
        GiacenzerifiutiComponent,
        NicaFiltroComponent,
        DistinctArrayPipe,
        ReplaceUndefinedPipe,
        SafePipe,
        NicaplayerComponent,
        GrigliaModelliComponent,
        AnaAlboComponent,
        EditSearchComponent,
        ConfigurazioniModuliComponent,
        DettagliMovimentiCaricoScaricoComponent,
        StampaRegistriCaricoScaricoComponent,
        PannelloGestioneStruttureExcelComponent,

        //ExtendnicaanagraficaComponent,
        StaticMenuComponent,
        StaticMenuFunctionsComponent,

        HomepagewwComponent,
        RemoveTextBetweenCharactersPipe,
        EditgiacenzainizialeComponent,
        EditorElementComponent,
        NicaGridComponent,
        GestioneCarichiMovimentoComponent,
        GestioneAltriSoggettiComponent,
        LottoComponent,
        NicaWrapperComponent,
        NicaPopupContentComponent,
        NicaPopupWrapperComponent,
        NewNicaFormComponent,
        NicaFormTabsComponent,
        InputSelectElComponent,
        InputFileElComponent,
        GiacenzeRifiutoMovimentoComponent,
        NicaDataGridComponent,
        GestioneLavorazioniRifiutiComponent,
        TdItemComponent,
        TestiAdrComponent,
        AnaMagazziniComponent,
        GestioneMiscelazioniRifiutiComponent,
        GestioneRintracciabilitaRifiutiComponent,
        InputCheckboxElComponent,
        InfousergruppiComponent,
        WebcamnicaComponent,
        ExtendfilterComponent,
        InputDateboxElComponent,
        DynamicSelectComponent,
        SelectCausaliPosizioniComponent,
        AnaAutistiComponent,
        AnaCantieriComponent,
        AnaLottiComponent,
        InputRadiogroupElComponent,
        AnaSchedaRifiutiComponent,
        GiacenzeRifiutiComponent,
        ExtendfilterComponent,
        ToolbarNavigationComponent,
        WidgetGiacenzaComponent,
        WidgetGraficiComponent,
        ShowRentriComponent,
        PippoComponent,
        ShowRentriElencoMovimentiComponent,
        CrmElencoRecapitiComponent,
        CrmProcedureComponent,
        CrmAgentiComponent,
        CrmTabPanelComponent,
        CrmBancheComponent,
        CrmAssegnaProcedureComponent,
        CrmDiarioAttivitaComponent,
        CrmTipoProcedureComponent,
        CrmVistaProcedureContattiComponent,
        CrmDashboardComponent,
        CrmLineChartStatisticheComponent,
        CrmStatProcedureComponent,
        CrmStatisticheComponent,
        CrmPieChartComponent,
        CrmTagsListComponent,
        CrmDettagliProcedureContattiComponent,
        CrmMasterDetailContattiComponent,
        CrmSediContattoComponent,
        InputSwitchElComponent,
        ElencoAttivitaComponent,
        RiepilogoProceduraComponent,
        HoverTooltipDirective,
        CrmMailComponent,
        CrmEmailEditorComponent,
        FileDragDropDirective,
        CrmEmailInviateComponent,
        NicaPopupTextComponent,
        CrmAggiornamentiComponent,
        CrmSendMessaggeComponent,
        CheckVisualElComponent,
        AllineaRegistroRentriComponent,
        GaugesOwnerComponent,
        PopupStampaRegistriComponent,
        PopupEsportazioneRentriComponent,
        PopupEsportazioneFilesComponent,
        StampaContrattoComponent,
        NewNicaAiComponent,
        DynamicHostDirective,
        DynamicContentAiComponent,
        GestioneFormulariComponent,
        PopupGestioneFirDigitaliComponent,
        CrmComuniComponent,
        DatiTrasportoComponent,
        AggiungiAllegatoComponent,
        AggiungiAnnotazioneComponent,
        AnnullamentoComponent,
        AggiungiNuovoDestinatarioComponent,
        DatiAccettazioneComponent,
        NicaPopupPdfComponent,
        DatiQuantitaComponent,
        NicaToastComponent,
        GestioneDispositiviComponent,
        AssociaDispositivoComponent,
        ListaAllegatiAnnotazioniComponent,
        NicaTreCxCallComponent
    ],

    entryComponents: [
        StatisticarifiutiGraficiComponent,
        ToolbarNavigationComponent,
        WidgetGiacenzaComponent,
        WidgetGraficiComponent,
        ExtendfilterComponent,
        WebcamnicaComponent,
        CrmContattiComponent,
        CrmTabPanelComponent,
        CrmDashboardComponent,
        CrmAssegnaProcedureComponent,
        CrmVistaProcedureContattiComponent,
        CrmFilesListComponent,
        Componente1Component,
        InfousergruppiComponent,
        GestioneMiscelazioniRifiutiComponent,
        GestioneRintracciabilitaRifiutiComponent,
        TestiAdrComponent,
        NicaGridComponent,
        EmissioneFormulariComponent,
        OverlaySideFormComponent,
        EditgiacenzainizialeComponent,
        NicaAnagraficaComponent,
        GrigliaComponent,
        NicaDataGridComponent,
        TestComponent,
        EditSearchComponent,
        GiacenzeRifiutiComponent, //Originale e buon
        GiacenzerifiutiComponent, //è solo un test
        ImballiComponent,
        SchedarifiutiComponent,
        EditAutocompleteComponent,
        MovimentiCaricoScaricoComponent,
        EmissioneFormulariComponent,
        PermessiutentiComponent,
        ExcelExporterComponent,
        EditgruppiComponent,
        GruppiComponent,
        NicaGestioneAziendaComponent,
        CaptionComponent,
        AnaProduttoriComponent,
        NicaLicenzaInfoComponent,
        PosizioniComponent,
        HomepageComponent,
        HomepagewwComponent,
        NicaFileManagerComponent,
        OdataComuniComponent,
        TabellaCausaliRifiutiComponent,
        RegistririfiutiComponent,
        GestioneautomezzicerComponent,
        GestionecerComponent,
        CarrozzeriemobiliComponent,
        ElencocertrasportabiliComponent,
        CausalirifiutiComponent,
        CantiereComponent,
        MagazzinoComponent,
        MagazzinoRifiutiCerComponent,
        SoggettoComponent,
        MainAnaSoggettoComponent,
        AnaSoggettoComponent,
        ConfigurazioniModuliComponent,
        ContattiComponent,
        NicaInfoAnagraficaAziendaComponent,
        AnaAutorizzazioneComponent,
        AnaAlboComponent,
        AnaAutomezzoComponent,
        AutistiComponent,
        AnaUnitaLocaliComponent,
        NicaTabComponent,
        NicaMapsComponent,
        DashboardComponent,
        NicaChartMakerComponent,
        CerComponent,
        AnteprimaPDfComponent,
        AnacomuniComponent,
        AllegatiComponent,
        DetailComponent,
        FormulariRentriComponent,
        MovimentiComponent,
        NicaFormComponent,
        NicaDynamicContentComponent,
        AnagraficaGridComponent,
        VivifirComponent,
        ConfigurazioneRentriComponent,
        NicaLicenzaInfoComponent,
        NicaChartMakerFormComponent,
        NicaGestioneAziendaComponent,
        NicaFiltroComponent,
        GenerateFormComponent,
        GrigliaModelliComponent,
        StampaRegistriCaricoScaricoComponent,
        PannelloGestioneStruttureExcelComponent,
        GestioneCarichiMovimentoComponent,
        GestioneAltriSoggettiComponent,
        LottoComponent,
        GiacenzeRifiutoMovimentoComponent,
        GestioneLavorazioniRifiutiComponent,
        AnaMagazziniComponent,
        NewNicaFormComponent,
        NicaFormTabsComponent,
        SelectCausaliPosizioniComponent,
        StatisticheRifiutiComponent,
        DynamicSelectComponent,
        ShowRentriElencoMovimentiComponent,
        CrmBancheComponent,
        CrmElencoRecapitiComponent,
        CrmProcedureComponent,
        CrmAgentiComponent,
        CrmDiarioAttivitaComponent,
        CrmTipoProcedureComponent,
        CrmLineChartStatisticheComponent,
        CrmStatProcedureComponent,
        CrmStatisticheComponent,
        CrmPieChartComponent,
        CrmTagsListComponent,
        CrmDettagliProcedureContattiComponent,
        CrmMasterDetailContattiComponent,
        CrmSediContattoComponent,
        InputSwitchElComponent,
        ElencoAttivitaComponent,
        RiepilogoProceduraComponent,
        CrmMailComponent,
        CrmEmailEditorComponent,
        CrmEmailInviateComponent,
        NicaPopupTextComponent,
        CrmAggiornamentiComponent,
        CrmSendMessaggeComponent,
        CheckVisualElComponent,
        AllineaRegistroRentriComponent,
        GaugesOwnerComponent,
        PopupStampaRegistriComponent,
        PopupEsportazioneRentriComponent,
        PopupEsportazioneFilesComponent,
        StampaContrattoComponent,
        NewNicaAiComponent,
        DynamicContentAiComponent,
        GestioneFormulariComponent,
        PopupGestioneFirDigitaliComponent,
        CrmComuniComponent,
        NicaPopupPdfComponent,
        GestioneDispositiviComponent,
        AssociaDispositivoComponent,
        ListaAllegatiAnnotazioniComponent,
        NicaTreCxCallComponent
    ],
    imports: [
        BrowserAnimationsModule,
        TooltipModule.forRoot(),
        ModalModule.forRoot(),
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        DxFormModule,
        DxMultiViewModule,
        DxMenuModule,
        DxLoadPanelModule,
        DxRangeSelectorModule,
        DxPopupModule,
        DxPopoverModule,
        DxChartModule,
        DxPieChartModule,
        DxVectorMapModule,
        DxDataGridModule,
        DxBulletModule,
        DxButtonModule,
        DxProgressBarModule,
        DxListModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxNumberBoxModule,
        DxResponsiveBoxModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxBoxModule,
        DxTextAreaModule,
        DxRadioGroupModule,
        DxDrawerModule,
        NgxSpinnerModule,
        DxFileUploaderModule,
        DxDropDownBoxModule,
        DxDropDownButtonModule,
        BrowserAnimationsModule,
        DxTabPanelModule,
        DxTabsModule,
        DxDateBoxModule,
        DxToolbarModule,
        DxTreeListModule,
        DxTreeViewModule,
        DxRangeSliderModule,
        SideNavigationMenuModule,
        DxTooltipModule,
        DxTemplateModule,
        DxSpeedDialActionModule,
        DxLoadIndicatorModule,
        DxRadioGroupModule,
        DxFileManagerModule,
        DxHtmlEditorModule,
        DxMapModule,
        DxContextMenuModule,
        FormsModule,
        DxTagBoxModule,
        DxButtonGroupModule,
        DxAutocompleteModule,
        DxScrollViewModule,
        DxLookupModule,
        DxAccordionModule,
        DxLoadPanelModule,
        DxColorBoxModule,
        DxSwitchModule,
        ReactiveFormsModule,
        NgbTooltipModule,
        DxLinearGaugeModule,
        QRCodeModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        NicaGridService,
        AnagraficaService,
        Apiservice,
        Utenteservice,
        ThemeService,
        ScreenService,
        OverlaySideFormService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true,
        },
    ],

    bootstrap: [AppComponent],
    exports: [UppercaseDirective, NumbersOnlyDirective],
})
export class AppModule { }
